<p>reporting-sidebar works!</p>
